import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Table from './../../../components/table';
import { resolveRoleName, getViceVersaFullName } from '../../../utilities/string';
import { sortByRoleThenName } from '../../../utilities/sortUser';
import SearchBar from '../../../components/searchBar';
import { InviteUserButton } from '../../../components/richButtons';
import { history } from '../../../configuration/store';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

class UsersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: undefined
        };

        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.getActionColumnDefinition = this.getActionColumnDefinition.bind(this);
        this.sortByName = this.sortByName.bind(this);
    }

    getActionColumnDefinition() {
        return {
            valueMap: d => (
                <div className="full-height-cell">
                    <i className="material-icons" onClick={() => console.log('edit ...')}>
                        edit
                    </i>
                    <i className="material-icons" onClick={() => console.log('delete ...')}>
                        delete
                    </i>
                </div>
            ),
            size: 'col-sm-2 col-xs-12 text-right'
        };
    }

    sortByName(a, b) {
        return getViceVersaFullName(a).localeCompare(getViceVersaFullName(b));
    }

    getClientName(user) {
        return user.roles && user.roles.length > 0 ? user.roles[0].resource_name : '';
    }

    getColumnDefinition() {
        const { role } = this.props;
        let showCompanyColumn = role.type === 'admin';

        const action = user => {
            const { id, roles } = user;
            const role = roles && roles.length > 0 ? roles[0] : undefined;
            if (role) {
                const { resource, resource_id } = role;
                history.push(`/user/${resource}/${resource_id}/${id}`);
            }
        };

        let columns = [
            {
                label: <FormattedMessage {...messages.name} />,
                valueMap: d => (
                    <div className="row name-column clickable" onClick={() => action(d)}>
                        <div className="col-xs-12 name-cell ellipsis">{getViceVersaFullName(d)}</div>
                        <div className="col-xs-12 email-cell ellipsis">{d.email}</div>
                    </div>
                ),
                size: showCompanyColumn ? 'col-md-3 col-sm-6 col-xs-10' : 'col-md-6 col-sm-9 col-xs-10',
                sort: this.sortByName
            },
            {
                label: <FormattedMessage {...messages.phone} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => action(d)}>
                        {d.phone ? formatPhoneNumberIntl(d.phone) : <FormattedMessage {...messages.notProvided} />}
                    </div>
                ),
                size: 'col-md-3 hidden-sm hidden-xs',
                sort: (a, b) => (a.phone || '').localeCompare(b.phone || '')
            },
            {
                label: <FormattedMessage {...messages.role} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis clickable" onClick={() => action(d)}>
                        {d.roles && d.roles.length > 0 ? resolveRoleName(d.roles[0].role) : <FormattedMessage {...messages.notProvided} />}
                    </div>
                ),
                size: 'col-sm-3 hidden-xs',
                sort: sortByRoleThenName,
                descSort: (a, b) => sortByRoleThenName(b, a, true)
            }
        ];

        if (showCompanyColumn) {
            columns = [
                ...columns,
                {
                    label: <FormattedMessage {...messages.company} />,
                    valueMap: d => (
                        <div className="full-height-cell ellipsis clickable" onClick={() => action(d)}>
                            {this.getClientName(d)}
                        </div>
                    ),
                    size: 'col-sm-3 hidden-xs',
                    sort: (a, b) => this.getClientName(a).localeCompare(this.getClientName(b))
                }
            ];
        }

        return columns;
    }

    render() {
        const { users } = this.props;
        const { searchString } = this.state;

        const removeSymbols = s => s.replace(/[- ()]/g, '');
        const searchVal = searchString && removeSymbols(searchString.toLowerCase());

        const matchEmail = user => (user.email ? user.email.toLowerCase() : '');
        const matchName = user => (user.first_name && user.last_name ? `${user.first_name} ${user.last_name}`.toLowerCase() : '');
        const matchClient = user => this.getClientName(user).toLowerCase();
        const matchPhone = user => (user.phone ? removeSymbols(user.phone) : '');
        const searchStringFilter = user =>
            matchEmail(user).indexOf(searchVal) >= 0 ||
            matchName(user).indexOf(searchVal) >= 0 ||
            matchClient(user).indexOf(searchVal) >= 0 ||
            matchPhone(user).indexOf(searchVal) >= 0;
        let data = searchString ? users.filter(searchStringFilter) : users;

        const button = (
            <span className="button">
                <FormattedMessage {...messages.inviteUser} />
            </span>
        );
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                    </div>
                    <div className="col-sm-6 col-xs-12 add-wrapper">
                        <InviteUserButton button={button} />
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table data={data} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                </div>
            </React.Fragment>
        );
    }
}

UsersList.defaultProps = {
    users: [],
    role: undefined
};
UsersList.propTypes = {
    users: PropTypes.array.isRequired,
    role: PropTypes.object.isRequired
};

export default UsersList;



// WEBPACK FOOTER //
// ./src/pages/users/lists/users.jsx